module.exports = __webpack_public_path__ + "img/img3.49037b87.jpg";